import { AnyAction } from '@reduxjs/toolkit';
import { GetCustomersRoutine } from '~modules/Companies/redux-routines';
import type { TCustomersListState } from '../interfaces';

export const initialState: TCustomersListState = {
  data: [],
  error: null,
  isLoading: false,
};

export const customersListReducer = (
  state: TCustomersListState = initialState,
  action: AnyAction,
): TCustomersListState => {
  switch (action.type) {
    case GetCustomersRoutine.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GetCustomersRoutine.SUCCESS: {
      return {
        ...state,
        data: GetCustomersRoutine.getSuccessPayload(action),
        isLoading: false,
      };
    }
    case GetCustomersRoutine.FAILURE: {
      return {
        ...state,
        error: GetCustomersRoutine.getFailurePayload(action),
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
